export const PROJECTS_SORTING = 'cols_order_project';
